import React, { createContext, useRef, useState } from "react";
import { useLocalStorage } from "../../core";
export const BotContext = createContext();

const BotContextProvider = ({ children }) => {
  const config = JSON.parse(sessionStorage.getItem("config"));
  const [font] = useLocalStorage("fontSize");
  const [rooms, setRooms] = useState(undefined);
  const [chats, setChats] = useState(undefined);
  const [selectedRoom, setSelectedRoom] = useState(undefined);
  const [buttonProps, setButtonProps] = useState(undefined);
  const [globalProps, setGlobalProps] = useState(undefined);
  const [page, setPage] = useState(1);
  const [chatsArray, setChatsArray] = useState(undefined);
  const [showWelcome, setShowWelcome] = useState(false);
  const [fontSize, setFontSize] = useState(font);
  const [askedQusetions, setAskedQuestions] = useState([
    {
      question: "",
      label_question: "",
    },
  ]);
  const [widgetHistory, setWidgetHistory] = useState([]);
  const inputRef = useRef(null);
  const [historyUser, setHistoryUser] = useLocalStorage("historyUser");
  const [isAdmin, setIsAdmin] = useState(false);
  const [users, setUsers] = useState(undefined);
  const [tokenUser, setTokenUser] = useState(undefined);
  const [chatStateMode, setChatStateMode] = useState(undefined)
  const [lastLVA, setLastLVA] = useState(undefined);
  const [lastAnswerId, setLastAnswerId] = useState(undefined)
  const [isHistoryReady, setIsHistoryReady] = useState(false)

  return (
    <BotContext.Provider
      value={{
        rooms,
        setRooms,
        selectedRoom,
        setSelectedRoom,
        chats,
        setChats,
        buttonProps,
        setButtonProps,
        globalProps,
        setGlobalProps,
        page,
        setPage,
        chatsArray,
        setChatsArray,
        showWelcome,
        setShowWelcome,
        fontSize,
        setFontSize,
        askedQusetions,
        setAskedQuestions,
        inputRef,
        historyUser,
        setHistoryUser,
        isAdmin,
        setIsAdmin,
        users,
        setUsers,
        config,
        tokenUser,
        setTokenUser,
        widgetHistory,
        setWidgetHistory,
        chatStateMode,
        setChatStateMode,
        lastLVA,
        setLastLVA,
        lastAnswerId,
        setLastAnswerId,
        isHistoryReady,
        setIsHistoryReady
      }}
    >
      {config ? children : null}
    </BotContext.Provider>
  );
};

export { BotContextProvider };
